/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
import Cookies from 'js-cookie';
import axios from 'axios';
import { apiClient, handleResponse } from './axios';

async function createUser(user) {
  user.isEW = true;
  try {
    const response = await axios.post('/student', user);
    const data = await handleResponse(response);
    const expiring = new Date();
    expiring.setMinutes(60 * 5 + 5);
    Cookies.set('auth', data.token, { expires: expiring }, { secure: true }, { sameSite: 'strict' });
    Cookies.set('refresh', data.refreshToken, { expires: expiring }, { secure: true }, { sameSite: 'strict' });
    return data;
  } catch {
    const res = await Promise.reject(new Error('Erreur pendant la création du compte'));
    return res;
  }
}

const sendNewPassword = async (values) => {
  const body = {
    token: values.token,
    password: values.password,
  };

  try {
    const response = await axios.put('/resetPassword', body);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.status === 400) {
      Promise.reject(new Error('Invalid body'));
    } else if (error.status === 404) {
      Promise.reject(new Error('Token expired, please ask for a new password'));
    } else if (error.status === 500) {
      Promise.reject(new Error('Server was unable to reset your password'));
    }
    return error.response.data.message;
  }
};

async function updateSatisfaction(userId) {
  try {
    const response = await axios.put(`/customer/satisfaction/${userId}`, {});
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error);
    return res;
  }
}

async function verifyEmail(email) {
  try {
    const response = await axios.post('/student/email/', { email });
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error);
    return res;
  }
}

async function verifyAccount(id, code) {
  try {
    const response = await axios.post(`/confirmation/${id}/${code}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function sendNewMail(user, site) {
  user.typeSite = site.typeSite;
  try {
    const response = await axios.post('/student/sendnewmail', user);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function putStudentCatchUp(studentId, semester, body) {
  const response = await apiClient
    .put(`/student/catchup/${studentId}/${semester}/`, body);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsPreviousGroups(studentId) {
  const response = await apiClient
    .get(`/student/group/previous/${studentId}/`);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsWithGradeBySemester(companyid, semester) {
  const response = await apiClient
    .get(`/student/test/company/${companyid}/${semester}`);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsWithGrade(companyid) {
  const response = await apiClient
    .get(`/student/test/company/${companyid}/`);
  const data = await handleResponse(response);
  return data;
}

async function deleteStudent(userId) {
  const response = await apiClient
    .delete(`/student/${userId}/654cae9381d371f4b9bef70c`);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsByCatchUpSemester(companyId, semester) {
  const response = await apiClient
    .get(`/student/catchup/${companyId}/${semester}`);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsWithoutGrade(companyid) {
  const response = await apiClient
    .get(`/student/notest/company/${companyid}/`);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsByCodes(companyId, codes) {
  const response = await apiClient.post(`/student/codes/${companyId}`, {
    codes,
  });
  const data = await handleResponse(response);
  return data;
}

async function getStudentsByCompany(companyId) {
  const response = await apiClient
    .get(`/student/company/${companyId}`);
  const data = await handleResponse(response);
  return data;
}

async function getStudentsBySemester(companyId, semester) {
  const response = await apiClient
    .get(`/student/semester/${companyId}/${semester}`);
  const data = await handleResponse(response);
  return data;
}

async function forgotPassword(email) {
  const body = JSON.stringify({ email, type: 'student', school: 'ew' });
  const response = await apiClient.post('/forgotPassword', body);
  const res = await handleResponse(response);
  return res;
}

async function refreshAuth(email, refreshToken) {
  const body = JSON.stringify({ email, refreshToken });

  const response = await axios.post('/refresh', body);
  const auth = await handleResponse(response);
  return auth;
}

async function login(email, password, rememberMe, type) {
  const body = JSON.stringify({
    email, password, rememberMe, type,
  });
  const response = await apiClient.post('/customer/login', body);
  const user = await handleResponse(response);
  return user;
}

async function impersonateLogin(adminMail, email, password, rememberMe, type) {
  const body = JSON.stringify({
    adminMail, email, password, rememberMe, type,
  });
  const response = await apiClient.post('/customer/login', body);
  const user = await handleResponse(response);
  return user;
}

async function getUserById(user) {
  const response = await apiClient.get(`/customer/${user}`);
  const user1 = await handleResponse(response);
  return user1;
}

async function getStudentById(user) {
  const response = await apiClient.get(`/student/${user}`);
  const user1 = await handleResponse(response);
  return user1;
}

async function getUserReferent() {
  const response = await apiClient.get('/user/type/2');
  const data = await handleResponse(response);
  return data;
}

async function updateUser(id, body) {
  const response = await apiClient.put(`/user/${id}`, body);
  const data = await handleResponse(response);
  return data;
}

function generateLoginToken(auth) {
  const expiring = new Date();
  expiring.setMinutes(60 * 5 + 5);
  Cookies.set('auth', auth.token, { expires: expiring }, { secure: true }, { sameSite: 'strict' });
  Cookies.set('refresh', auth.refreshToken, { expires: expiring }, { secure: true }, { sameSite: 'strict' });
  Cookies.set('company', auth.company, { expires: expiring }, { secure: true }, { sameSite: 'strict' });
}

async function deleteUser(userId) {
  const response = await apiClient.delete(`/user/${userId}`);
  const data = await handleResponse(response);
  return data;
}

function logout() {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('auth');
  Cookies.remove('refresh');
  window.location.reload();
}

async function deleteUsersFromSubGroup(groupId, subgroupId, usersId) {
  const response = await apiClient
    .put(`/group/subgroup/remove/${groupId}/${subgroupId}`, { users: usersId });
  const data = await handleResponse(response);
  return data;
}

async function addUsersToSubGroup(groupId, subgroupId, userIds) {
  const response = await apiClient
    .put(`/group/subgroup/${groupId}/${subgroupId}`, { users: userIds });
  const data = await handleResponse(response);
  return data;
}

async function setUnitTracker(userId, unitId, time) {
  const body = {
    unit: unitId,
    time,
  };

  try {
    const response = await apiClient.put(`/unittrackers/timer/${userId}`, body);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getPlacementTest(studentId) {
  try {
    const res = await apiClient.get(`/test/user/${studentId}`);
    return res.data;
  } catch (err) {
    const res = await Promise.reject(err.response.data.message);
    return res;
  }
}
async function getGrades(studentId) {
  try {
    const response = await apiClient.get(`/grade/last/user/${studentId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}
async function getValidatedReports(studentId) {
  try {
    const response = await apiClient.get(`/reports/${studentId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

export const userServices = {
  login,
  logout,
  deleteUsersFromSubGroup,
  getUserById,
  forgotPassword,
  sendNewPassword,
  generateLoginToken,
  addUsersToSubGroup,
  refreshAuth,
  verifyAccount,
  getStudentsWithoutGrade,
  sendNewMail,
  getUserReferent,
  deleteStudent,
  getStudentById,
  getStudentsByCodes,
  deleteUser,
  updateUser,
  putStudentCatchUp,
  getStudentsWithGrade,
  getStudentsWithGradeBySemester,
  getStudentsByCatchUpSemester,
  getStudentsBySemester,
  getStudentsByCompany,
  getPlacementTest,
  getGrades,
  getValidatedReports,
  updateSatisfaction,
  getStudentsPreviousGroups,
  verifyEmail,
  createUser,
  setUnitTracker,
  impersonateLogin,
};
